import Base from 'common/constants';
import { CommonAxiosAPIHandler } from 'common/helpers';

export const GetOfficeForDesignatedBroker = (designatedBrokerID) => {
    return CommonAxiosAPIHandler('GET', [
        `${Base.GET_OFFICE_FOR_DESIGNATED_BROKER}?designatedBroker=${encodeURIComponent(
            designatedBrokerID
        )}`,
    ]);
};

export const GetAgentsForOffice = (officeID) => {
    return CommonAxiosAPIHandler('GET', [
        `${Base.GET_AGENT_FOR_OFFICE}?officeID=${encodeURIComponent(officeID)}`,
    ]);
};

export const GetBrokerageAddressDetails = (
    countyID,
    brokerageName,
    addressCityID = '-'
) => {
    return CommonAxiosAPIHandler('GET', [
        `${Base.GET_BROKERAGE_ADDRESS_DETAILS}?countyID=${countyID}&brokerageName=${encodeURIComponent(
            (brokerageName || '').toLowerCase()
        )}&addressCityID=${encodeURIComponent(addressCityID || '-')}`,
    ]);
};

export const GetManagingBrokerDetails = (
    countyID,
    brokerageName,
    addressCityID = '-'
) => {
    return CommonAxiosAPIHandler('GET', [
        `${Base.GET_MANAGING_BROKER_DETAILS}?countyID=${countyID}&brokerageName=${encodeURIComponent(
            (brokerageName || '').toLowerCase()
        )}&addressCityID=${encodeURIComponent(addressCityID || '-')}`,
    ]);
};
